// El dashboard Directivo Muestra las gráficas y KPIs sobre la salud del negocio que construimos.
import React, { useState, useEffect } from 'react';
import { db } from '../firebase/config'
import { PROYECTOS_COLLECTION, monthNames, StatusBadge } from '../utils/constants'
import { 
    collection, query, where, getDocs
} from 'firebase/firestore';
import { Bar, Line } from 'react-chartjs-2';
import { formatDate } from '../utils/helpers';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler
);


export const DirectivoDashboard = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [dashboardData, setDashboardData] = useState(null);
    const [view, setView] = useState('kpis');
    const [billingMonthViewOffset, setBillingMonthViewOffset] = useState(0);
    const [paidMonthViewOffset, setPaidMonthViewOffset] = useState(0);

    /**
     * @param {Array} projects
     * @param {Array} invoices
     * @param {Array} technicians
     * @param {string} sortBy
     * @param {string} sortOrder
     * @returns {Object}
     */
    const processDataForDashboard = (projects, invoices, technicians) => {
        const currentYear = new Date().getFullYear();
        const labels = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const oneDay = 1000 * 60 * 60 * 24;
        const monthlyProjectsData = Array(12).fill(0).map(() => ({ cotizacion: 0, activo: 0, pendienteFactura: 0, total: 0 }));
        const monthlyARData = Array(12).fill(0).map(() => ({ totalFacturado: 0, pdteProgramacion: 0, programado: 0, venceHoy: 0, vencido: 0, pagado: 0 }));
        const monthlyPaidData = Array(12).fill(0);
        const monthlyProgrammedData = Array(12).fill(0);
        const weeklyCashFlowData = Array(8).fill(0).map(() => ({ ingresos: 0, egresos: 0 }));
        const allAccountsReceivable = [];
        const allAccountsPayable = [];
        const projectsMap = new Map(projects.map(p => [p.id, p]));
        const techniciansMap = {};
        technicians.forEach(t => { techniciansMap[t.id] = t.nombreCompleto; });
        const techRevenueData = {};
        technicians.forEach(t => { techRevenueData[t.id] = { label: t.nombreCompleto.split(' ')[0], data: Array(12).fill(0) }; });

        let totalDeliveryDays = 0, completedProjects = 0;
        projects.forEach(p => {

            if (p.fechaApertura?.toDate && p.fechaApertura.toDate().getFullYear() === currentYear) {
                const month = p.fechaApertura.toDate().getMonth();
                const projectValue = p.precioCotizacionCliente || 0;
                monthlyProjectsData[month].total += projectValue;
                switch (p.estado) {
                    case 'Cotización': monthlyProjectsData[month].cotizacion += projectValue; break;
                    case 'Activo': case 'Terminado Internamente': case 'En Revisión Final': monthlyProjectsData[month].activo += projectValue; break;
                    case 'Pendiente de Factura': monthlyProjectsData[month].pendienteFactura += projectValue; break;
                    default: break;
                }
            }

            const deliveryDate = p.fase2_fechaFinTecnico?.toDate() || p.fase1_fechaFinTecnico?.toDate();
            if (deliveryDate && deliveryDate.getFullYear() === currentYear && p.asignadoTecnicosIds && p.asignadoTecnicosIds.length > 0) {
                const month = deliveryDate.getMonth();
                const amount = p.precioCotizacionCliente || 0;
                const responsibleTechId = p.asignadoTecnicosIds[0];
                if (techRevenueData[responsibleTechId]) {
                    techRevenueData[responsibleTechId].data[month] += amount;
                }
            }

            if ((p.precioCotizacionCliente || 0) > 0 && (p.costoProveedor || 0) >= 0) {
                return (p.precioCotizacionCliente - p.costoProveedor) / p.precioCotizacionCliente;
            }
            if (p.fechaAsignacionTecnico?.toDate && (p.fase1_fechaFinTecnico?.toDate() || p.fechaFinTecnicoReal?.toDate())) {
                const finDate = p.fase1_fechaFinTecnico?.toDate() || p.fechaFinTecnicoReal?.toDate();
                totalDeliveryDays += (finDate - p.fechaAsignacionTecnico.toDate()) / oneDay;
                completedProjects++;
            }
        });

        invoices.forEach(inv => {
            const invoiceValue = inv.monto || 0;
            
            let calculatedStatus = 'Pend. de Autorización';
            let promiseDate = null;
            if (inv.estado === 'Pagada') { calculatedStatus = 'Pagada'; }
            else if (inv.estado === 'Cancelada') { calculatedStatus = 'Cancelada'; }
            else if (inv.fechaPromesaPago?.toDate) {
                promiseDate = inv.fechaPromesaPago.toDate();
                promiseDate.setHours(0, 0, 0, 0);
                if (promiseDate < today) { calculatedStatus = 'Vencida'; }
                else if (promiseDate.getTime() === today.getTime()) { calculatedStatus = 'Vence Hoy'; }
                else { calculatedStatus = 'Prog. a Pago'; }
            }
            inv.estado = calculatedStatus;


            if (inv.tipo === 'cliente') {

                if (inv.fechaEmision?.toDate && inv.fechaEmision.toDate().getFullYear() === currentYear) {
                    const month = inv.fechaEmision.toDate().getMonth();
                    if (inv.estado !== 'Cancelada') {
                        monthlyARData[month].totalFacturado += invoiceValue;
                    }
                    switch (inv.estado) {
                        case 'Pagada': monthlyARData[month].pagado += invoiceValue; break;
                        case 'Vencida': monthlyARData[month].vencido += invoiceValue; break;
                        case 'Vence Hoy': monthlyARData[month].venceHoy += invoiceValue; break;
                        case 'Prog. a Pago': monthlyARData[month].programado += invoiceValue; break;
                        case 'Pend. de Autorización': monthlyARData[month].pdteProgramacion += invoiceValue; break;
                        default: break;
                    }
                }

                if (inv.estado === 'Pagada' && inv.fechaPagoReal?.toDate) {
                    const paymentDate = inv.fechaPagoReal.toDate();
                    if (paymentDate.getFullYear() === currentYear) {
                        monthlyPaidData[paymentDate.getMonth()] += invoiceValue;
                    }
                }

                if (promiseDate && (inv.estado === 'Prog. a Pago' || inv.estado === 'Vencida' || inv.estado === 'Vence Hoy')) {
                    if (promiseDate.getFullYear() === currentYear) {
                        monthlyProgrammedData[promiseDate.getMonth()] += invoiceValue;
                    }
                }
            }

            let weekIndex = -1;
            
            if (inv.estado === 'Vencida') {
                weekIndex = 0;
            } else if (inv.estado === 'Prog. a Pago' || inv.estado === 'Vence Hoy') {
                const diffDays = Math.floor((promiseDate - today) / oneDay);
                const calculatedIndex = Math.floor(diffDays / 7);
                if (calculatedIndex >= 0 && calculatedIndex < 8) {
                    weekIndex = calculatedIndex;
                }
            }

            if (weekIndex >= 0) {
                if (inv.tipo === 'cliente') {
                    weeklyCashFlowData[weekIndex].ingresos += invoiceValue;
                } else {
                    weeklyCashFlowData[weekIndex].egresos += invoiceValue;
                }
            }
            
            const project = (inv.proyectoId && inv.proyectoId !== 'general') ? projectsMap.get(inv.proyectoId) : null;
            const processedInv = {
                ...inv,
                planta: project?.ubicacionCliente || project?.clienteNombre || inv.clienteNombre || inv.proveedorNombre || 'N/A',
                servicio: project?.servicioNombre || inv.descripcion || 'Gasto General',
            };
            if (inv.tipo === 'cliente') allAccountsReceivable.push(processedInv);
            if (inv.tipo === 'proveedor') allAccountsPayable.push(processedInv);
        });

        const kpis = {
            avgDeliveryDays: completedProjects > 0 ? (totalDeliveryDays / completedProjects).toFixed(1) : 0,
            monthlyBillingData: monthlyARData,
            monthlyPaidData: monthlyPaidData,
            monthlyProgrammedData: monthlyProgrammedData
        };

        const weeklyLabels = [];
        for (let i = 0; i < 8; i++) {
            const weekStartDate = new Date(today.getTime() + (i * 7 * oneDay));
            weeklyLabels.push(`Sem ${i + 1} (${weekStartDate.getDate()}/${weekStartDate.getMonth() + 1})`);
        }

        const colors = ['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)', 'rgba(75, 192, 192, 1)', 'rgba(255, 206, 86, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)'];
        const techDatasets = Object.values(techRevenueData).map((tech, index) => ({
            ...tech,
            borderColor: colors[index % colors.length],
            backgroundColor: colors[index % colors.length].replace('1)', '0.2)'),
            fill: true, tension: 0.1,
        }));
        
        const allOperationalProjects = projects.map(p => {
            const responsableId = p.asignadoTecnicosIds?.[0];
            let deliveryStatus = p.estado;
            let sortOrderValue = 99;
            if (p.estado === 'Activo') {
                if (p.fechaFinTecnicoReal) {
                    deliveryStatus = 'En Espera de Proveedor'; sortOrderValue = 4;
                } else {
                    const dueDate = p.fechaEntregaInterna?.toDate();
                    if (!dueDate) {
                        deliveryStatus = 'Sin Fecha'; sortOrderValue = 5;
                    } else {
                        dueDate.setHours(0, 0, 0, 0);
                        const diffDays = (dueDate - today) / (1000 * 60 * 60 * 24);
                        if (diffDays < 0) { deliveryStatus = 'Atrasado'; sortOrderValue = 1; }
                        else if (diffDays <= 3) { deliveryStatus = 'Por Vencer'; sortOrderValue = 2; }
                        else { deliveryStatus = 'A Tiempo'; sortOrderValue = 3; }
                    }
                }
            }
            return {
                ...p,
                responsableNombre: techniciansMap[responsableId] || 'No Asignado',
                notaEntregaNumero: p.fase2_numeroNotaInterna || p.fase1_numeroNotaInterna || 'N/A',
                fechaEntregaReal: p.fase1_fechaFinTecnico || p.fase2_fechaFinTecnico || p.fechaFinTecnicoReal,
                deliveryStatus: deliveryStatus,
                sortOrder: sortOrderValue,
            };
        });

        const accountsReceivableList = allAccountsReceivable
            .filter(inv => inv.estado !== 'Pagada' && inv.estado !== 'Cancelada')
            .sort((a, b) => (a.fechaPromesaPago?.toDate() || new Date('2999-12-31')) - (b.fechaPromesaPago?.toDate() || new Date('2999-12-31')));
        
        const accountsPayableList = allAccountsPayable
            .filter(inv => inv.estado !== 'Pagada' && inv.estado !== 'Cancelada')
            .sort((a, b) => (a.fechaPromesaPago?.toDate() || new Date('2999-12-31')) - (b.fechaPromesaPago?.toDate() || new Date('2999-12-31')));
        return {
            kpis,
            pipeline: { labels, cotizacionData: monthlyProjectsData.map(m => m.cotizacion), activoData: monthlyProjectsData.map(m => m.activo), pendienteFacturaData: monthlyProjectsData.map(m => m.pendienteFactura), totalData: monthlyProjectsData.map(m => m.total) },
            accountsReceivable: { labels, totalFacturadoData: monthlyARData.map(m => m.totalFacturado), pagadoData: monthlyARData.map(m => m.pagado), programadoData: monthlyARData.map(m => m.programado), venceHoyData: monthlyARData.map(m => m.venceHoy), vencidoData: monthlyARData.map(m => m.vencido), pdteProgramacionData: monthlyARData.map(m => m.pdteProgramacion) },
            cashFlow: { labels: weeklyLabels, ingresosData: weeklyCashFlowData.map(w => w.ingresos), egresosData: weeklyCashFlowData.map(w => w.egresos) },
            techRevenueChart: { labels, datasets: techDatasets },
            allOperationalProjects,
            techniciansMap,
            accountsReceivableList,
            accountsPayableList,
            projectsMap
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const projectsQuery = query(collection(db, PROYECTOS_COLLECTION));
                const invoicesQuery = query(collection(db, "facturas"));
                const techniciansQueryOld = query(collection(db, "usuarios"), where("rol", "==", "tecnico"));
                const techniciansQueryNew = query(collection(db, "usuarios"), where("roles", "array-contains", "tecnico"));

                const [projectsSnapshot, invoicesSnapshot, techniciansOldSnapshot, techniciansNewSnapshot] = await Promise.all([
                    getDocs(projectsQuery),
                    getDocs(invoicesQuery),
                    getDocs(techniciansQueryOld),
                    getDocs(techniciansQueryNew)
                ]);

                const allProjects = projectsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                const allInvoices = invoicesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                const techMap = new Map();
                techniciansOldSnapshot.forEach(doc => techMap.set(doc.id, { id: doc.id, ...doc.data() }));
                techniciansNewSnapshot.forEach(doc => techMap.set(doc.id, { id: doc.id, ...doc.data() }));
                const allTechnicians = Array.from(techMap.values());

                const processedData = processDataForDashboard(allProjects, allInvoices, allTechnicians, );
                setDashboardData(processedData);

            } catch (err) {
                console.error("Error al obtener datos para el dashboard directivo:", err);
                setError("No se pudieron cargar las métricas.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div className="text-center py-10">Calculando métricas... ⚙️</div>;
    }

    if (error) {
        return <div className="text-center py-10 text-red-600">{error}</div>;
    }

    const getInvoiceStatusBadge = (status) => {
        const styles = {
            'Pagada': 'bg-green-100 text-green-800',
            'Vencida': 'bg-red-100 text-red-800',
            'Prog. a Pago': 'bg-blue-100 text-blue-800',
            'Pend. de Autorización': 'bg-yellow-100 text-yellow-800',
            'Cancelada': 'bg-gray-100 text-gray-700',
        };
        return <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${styles[status] || 'bg-gray-100'}`}>{status}</span>;
    };

    return (
        <div className="space-y-8">
            <div>
                <h1 className="text-3xl font-bold text-gray-900">Dashboard Directivos</h1>
                <p className="text-gray-600">Vista general de la salud y rendimiento del negocio.</p>
            </div>
            <div className="mb-6 border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    <button onClick={() => setView('kpis')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'kpis' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Métricas y Finanzas
                    </button>
                    <button onClick={() => setView('operativo')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'operativo' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Seguimiento Operativo
                    </button>
                    <button onClick={() => setView('cobrar')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'cobrar' ? 'border-blue-500' : 'border-transparent text-gray-500'}`}>Cuentas por Cobrar</button>
                    <button onClick={() => setView('pagar')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'pagar' ? 'border-blue-500' : 'border-transparent text-gray-500'}`}>Cuentas por Pagar</button>
                </nav>
            </div>

            {view === 'kpis' && (
                <>
                    {dashboardData?.kpis && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                            <KPIWidget title="Tiempo Prom. Entrega" value={dashboardData.kpis.avgDeliveryDays} unit="días" />
                            {/*Widget de programado a pago del mes corriente */}
                            {(() => {
                                const currentMonthIndex = new Date().getMonth();
                                const kpiValue = dashboardData.kpis.monthlyProgrammedData[currentMonthIndex];
                                const kpiLabel = monthNames[currentMonthIndex];

                                return (
                                    <div className="bg-white p-5 rounded-xl shadow-md">
                                        <h3 className="font-bold text-gray-500">Programado ({kpiLabel})</h3>
                                        <p className="text-3xl font-bold mt-2">
                                            {kpiValue.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                        </p>
                                    </div>
                                );
                            })()}
                            {/* Widget de pagado en el mes y los dos anteriores */}
                            {(() => {
                                const currentMonthIndex = new Date().getMonth();
                                const allPaidData = dashboardData.kpis.monthlyPaidData;
                                const monthIndexToShow = (currentMonthIndex - paidMonthViewOffset + 12) % 12;
                                const kpiValue = allPaidData[monthIndexToShow];
                                const kpiLabel = monthNames[monthIndexToShow];

                                return (
                                    <div className="bg-white p-5 rounded-xl shadow-md relative">
                                        <div className="flex justify-between items-center mb-2">
                                            <h3 className="font-bold text-gray-500">Ingresos ({kpiLabel})</h3>
                                            <div className="flex space-x-1">
                                                <button onClick={() => setPaidMonthViewOffset(prev => (prev + 1) % 3)} /* ... */ >&#8592;</button>
                                                <button onClick={() => setPaidMonthViewOffset(prev => (prev - 1 + 3) % 3)} /* ... */ >&#8594;</button>
                                            </div>
                                        </div>
                                        <p className="text-3xl font-bold mt-2">
                                            {kpiValue.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                        </p>
                                    </div>
                                );
                            })()}
                            {/* Widget de facturado en el mes y los dos anteriores */}
                            {(() => {
                                const currentMonthIndex = new Date().getMonth();
                                const allBillingData = dashboardData.kpis.monthlyBillingData;
                                const monthIndexToShow = (currentMonthIndex - billingMonthViewOffset + 12) % 12;
                                const kpiValue = allBillingData[monthIndexToShow].totalFacturado;
                                const kpiLabel = monthNames[monthIndexToShow];

                                return (
                                    <div className="bg-white p-5 rounded-xl shadow-md relative">
                                        <div className="flex justify-between items-center mb-2">
                                            <h3 className="font-bold text-gray-500">Facturado ({kpiLabel})</h3>
                                            <div className="flex space-x-1">
                                                <button 
                                                    onClick={() => setBillingMonthViewOffset(prev => (prev + 1) % 3)} 
                                                    className="bg-gray-200 hover:bg-gray-300 text-gray-700 w-6 h-6 rounded-full flex items-center justify-center"
                                                    title="Mes anterior"
                                                >
                                                    &#8592;
                                                </button>
                                                <button 
                                                    onClick={() => setBillingMonthViewOffset(prev => (prev - 1 + 3) % 3)} 
                                                    className="bg-gray-200 hover:bg-gray-300 text-gray-700 w-6 h-6 rounded-full flex items-center justify-center"
                                                    title="Mes siguiente"
                                                >
                                                    &#8594;
                                                </button>
                                            </div>
                                        </div>
                                        <p className="text-3xl font-bold mt-2">
                                            {kpiValue.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                        </p>
                                    </div>
                                );
                            })()}
                        </div>
                    )}

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        <div className="bg-white p-6 rounded-xl shadow-md">
                            <h3 className="font-bold text-lg mb-4">Pipeline de Proyectos (Mensual)</h3>
                            <div className="h-80">
                                {dashboardData?.pipeline && <PipelineChart chartData={dashboardData.pipeline} />}
                            </div>
                        </div>
                        <div className="bg-white p-6 rounded-xl shadow-md">
                            <h3 className="font-bold text-lg mb-4">Salud de Cuentas por Cobrar (Mensual)</h3>
                            <div className="h-80">
                                {dashboardData?.accountsReceivable && <AccountsReceivableChart chartData={dashboardData.accountsReceivable} />}
                            </div>
                        </div>
                        <div className="bg-white p-6 rounded-xl shadow-md">
                            <h3 className="font-bold text-lg mb-4">Flujo de Caja Proyectado (Próximas 8 Semanas)</h3>
                            <div className="h-80">
                                {dashboardData?.cashFlow && <CashFlowChart chartData={dashboardData.cashFlow} />}
                            </div>
                        </div>
                        <div className="bg-white p-6 rounded-xl shadow-md">
                            <h3 className="font-bold text-lg mb-4">Monto Entregado por Técnico (Mensual)</h3>
                            <div className="h-80">
                                {dashboardData?.techRevenueChart && <TechnicianRevenueChart chartData={dashboardData.techRevenueChart} />}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {view === 'operativo' && dashboardData && (
                <OperationalReportTable
                    projects={dashboardData.allOperationalProjects}
                    techniciansMap={dashboardData.techniciansMap}
                />
            )}

            {view === 'cobrar' && dashboardData && (
                <FinancialTrackingTable
                    title="Cuentas por Cobrar"
                    invoices={dashboardData.accountsReceivableList}
                    getInvoiceStatusBadge={getInvoiceStatusBadge}
                />
            )}
            {view === 'pagar' && dashboardData && (
                <AccountsPayableDirectiveTable
                    invoices={dashboardData.accountsPayableList}
                    projectsMap={dashboardData.projectsMap}
                />
            )}
        </div>
    );
};

//Componente para renderizar la gráfica de Pipeline de Proyectos recibe los datos ya procesados y listos para mostrar.
const PipelineChart = ({ chartData }) => {
    const data = {
        labels: chartData.labels,
        datasets: [
            {
                label: 'Valor en Cotización',
                data: chartData.cotizacionData,
                backgroundColor: 'rgba(255, 159, 64, 0.7)',
            },
            {
                label: 'Valor Activo',
                data: chartData.activoData,
                backgroundColor: 'rgba(54, 162, 235, 0.7)',
            },
            {
                label: 'Valor Pdto. Factura',
                data: chartData.pendienteFacturaData,
                backgroundColor: 'rgba(255, 206, 86, 0.7)', 
            },
            {
                type: 'line', 
                label: 'Valor Total Ofertado',
                data: chartData.totalData,
                borderColor: 'rgba(75, 192, 192, 1)', 
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: true,
                tension: 0.2,
                yAxisID: 'y1',
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: false,
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
            legend: {
                position: 'bottom',
            }
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
                beginAtZero: true
            },
            y1: {
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                },
                beginAtZero: true,
            }
        },
    };

    return <Bar options={options} data={data} />;
};

//Componente para la gráfica de Salud de Cuentas por Cobrar.
const AccountsReceivableChart = ({ chartData }) => {
    const data = {
        labels: chartData.labels,
        datasets: [
            {
                label: 'Pagado',
                data: chartData.pagadoData,
                backgroundColor: 'rgba(75, 192, 192, 0.7)', 
            },
            {
                label: 'Programado a Pago',
                data: chartData.programadoData,
                backgroundColor: 'rgba(54, 162, 235, 0.7)', 
            },
            {
                label: 'Vence Hoy',
                data: chartData.venceHoyData,
                backgroundColor: 'rgba(255, 159, 64, 0.7)', 
            },
            {
                label: 'Vencido',
                data: chartData.vencidoData,
                backgroundColor: 'rgba(255, 99, 132, 0.7)', 
            },
            {
                label: 'Pdte. de Programación',
                data: chartData.pdteProgramacionData,
                backgroundColor: 'rgba(201, 203, 207, 0.7)', 
            },
            {
                type: 'line',
                label: 'Total Facturado',
                data: chartData.totalFacturadoData,
                borderColor: '#36A2EB',
                tension: 0.2,
                yAxisID: 'y1',
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: { display: false },
            tooltip: { mode: 'index', intersect: false },
            legend: { position: 'bottom' }
        },
        scales: {
            x: { stacked: true },
            y: { stacked: true, beginAtZero: true },
            y1: {
                position: 'right',
                grid: { drawOnChartArea: false },
                beginAtZero: true,
            }
        },
    };

    return <Bar options={options} data={data} />;
};

//Componente para la gráfica de Flujo de Caja Proyectado (Semanal).
const CashFlowChart = ({ chartData }) => {
    const data = {
        labels: chartData.labels,
        datasets: [
            {
                label: 'Ingresos Programados',
                data: chartData.ingresosData,
                borderColor: 'rgb(54, 162, 235)',
                backgroundColor: 'rgba(54, 162, 235, 0.5)',
                type: 'bar', 
            },
            {
                label: 'Egresos Programados',
                data: chartData.egresosData,
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                type: 'bar', 
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: { display: false },
            legend: { position: 'bottom' }
        },
        scales: {
            y: { beginAtZero: true }
        }
    };

    return <Bar options={options} data={data} />;
};

// El widget que muestra un KPI en el dashboard directivo.
const KPIWidget = ({ title, value, unit = '', trend = null }) => {
    return (
        <div className="bg-white p-5 rounded-xl shadow-md">
            <h3 className="font-bold text-gray-500 truncate">{title}</h3>
            <p className="text-3xl font-bold mt-2">
                {value}
                <span className="text-xl font-semibold ml-1">{unit}</span>
            </p>
        </div>
    );
};

const OperationalReportTable = ({ projects, techniciansMap }) => {
    const currentYear = new Date().getFullYear();
    const monthOptions = [
        { value: '', label: 'Todos los Meses' },
        ...monthNames.map((name, index) => ({ value: String(index), label: name }))
    ];
    
    const [reportType, setReportType] = useState('delivered');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [techFilter, setTechFilter] = useState('');

    const technicianOptions = React.useMemo(() => {
        if (!techniciansMap) return [];
        return Object.values(techniciansMap)
                     .filter((name, index, self) => self.indexOf(name) === index)
                     .sort()
                     .map(name => ({ value: name, label: name }));
    }, [techniciansMap]);

    const getDaysElapsed = (timestamp) => {
        if (!timestamp) return 0;
        const start = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        const now = new Date();
        const diff = now.getTime() - start.getTime();
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        return days > 0 ? days : 0;
    };

    const { filteredProjects, totalSum, totalLabel } = React.useMemo(() => {
        let filtered = [];
        if (reportType === 'delivered') {
            filtered = projects.filter(p => {
                const deliveryDate = p.fase1_fechaFinTecnico?.toDate() || p.fase2_fechaFinTecnico?.toDate();
                if (!deliveryDate) return false;
                const yearMatch = deliveryDate.getFullYear() === selectedYear;
                const monthMatch = !selectedMonth || deliveryDate.getMonth() === parseInt(selectedMonth, 10);
                return yearMatch && monthMatch;
            });
        } else {
            filtered = projects.filter(p => {
                const dueDate = p.fechaEntregaInterna?.toDate();
                const statusMatch = p.estado === 'Activo' && !p.fechaFinTecnicoReal;
                if (!dueDate) return statusMatch && !selectedMonth;
                const yearMatch = dueDate.getFullYear() === selectedYear;
                const monthMatch = !selectedMonth || dueDate.getMonth() === parseInt(selectedMonth, 10);
                return statusMatch && yearMatch && monthMatch;
            });
        }

        if (techFilter) {
            filtered = filtered.filter(p => p.responsableNombre === techFilter);
        }
        
        const sum = filtered.reduce((acc, p) => acc + (p.precioCotizacionCliente || 0), 0);
        
        filtered.sort((a, b) => {
            if (reportType === 'pending') {

                const orderA = a.sortOrder || 99;
                const orderB = b.sortOrder || 99;
                
                if (orderA !== orderB) {
                    return orderA - orderB;
                }
                
                const dateA = a.fechaEntregaInterna?.toDate() || 0;
                const dateB = b.fechaEntregaInterna?.toDate() || 0;
                return dateA - dateB; 
            } else {
                const dateA = (a.fase2_fechaFinTecnico || a.fase1_fechaFinTecnico)?.toDate() || 0;
                const dateB = (b.fase2_fechaFinTecnico || b.fase1_fechaFinTecnico)?.toDate() || 0;
                return dateB - dateA;
            }
        });

        const label = selectedMonth ? `${monthNames[parseInt(selectedMonth, 10)]} ${selectedYear}` : `Todo ${selectedYear}`;
        
        return { filteredProjects: filtered, totalSum: sum, totalLabel: label };
    }, [projects, reportType, selectedMonth, selectedYear, techFilter]);

    const currentItems = filteredProjects.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

    return (
        <div>
            <div className="mb-4 p-4 bg-gray-50 rounded-lg border flex flex-wrap items-center gap-x-6 gap-y-4">
                <div className="flex items-center space-x-2">
                    <label className="text-sm font-medium">Ver:</label>
                    <select value={reportType} onChange={e => { setReportType(e.target.value); setCurrentPage(1); }} className="border-gray-300 rounded-md p-2 text-sm">
                        <option value="delivered">Entregados</option>
                        <option value="pending">Pendientes</option>
                    </select>
                </div>
                <div className="flex items-center space-x-2">
                    <label className="text-sm font-medium">Mes:</label>
                    <select value={selectedMonth} onChange={e => { setSelectedMonth(e.target.value); setCurrentPage(1); }} className="border-gray-300 rounded-md p-2 text-sm">
                        {monthOptions.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                    </select>
                </div>
                 <div className="flex items-center space-x-2">
                    <label className="text-sm font-medium">Año:</label>
                    <select value={selectedYear} onChange={e => { setSelectedYear(parseInt(e.target.value, 10)); setCurrentPage(1); }} className="border-gray-300 rounded-md p-2 text-sm">
                         {yearOptions.map(year => <option key={year} value={year}>{year}</option>)}
                    </select>
                </div>
                <div className="flex items-center space-x-2">
                    <label className="text-sm font-medium">Responsable:</label>
                    <select value={techFilter} onChange={e => { setTechFilter(e.target.value); setCurrentPage(1); }} className="border-gray-300 rounded-md p-2 text-sm">
                        <option value="">Todos</option>
                        {technicianOptions.map(tech => <option key={tech.value} value={tech.value}>{tech.label}</option>)}
                    </select>
                </div>
                 <div className="flex items-center space-x-2 ml-auto">
                    <span className="text-sm">Mostrar:</span>
                    <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }} className="px-2 py-1 border border-gray-300 rounded-md">
                        <option value={10}>10</option><option value={15}>15</option><option value={25}>25</option>
                    </select>
                </div>
            </div>

            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Cliente</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Proyecto</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Monto</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Responsable</th>
                            {reportType === 'pending' && (
                                <>
                                    <th className="px-4 py-2 text-left text-xs font-medium uppercase">Estatus</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium uppercase">Notas</th>
                                    <th className="px-4 py-2 text-left text-xs font-medium uppercase">Fecha de Activacion</th>
                                    <th className="px-4 py-2 text-center text-xs font-medium uppercase">Días Transcurridos</th>
                                </>
                            )}
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">{reportType === 'delivered' ? 'Nota Entrega' : 'Fecha Límite'}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {currentItems.map(p => (
                            <tr key={p.id}>
                                <td className="px-4 py-2">{p.clienteNombre}</td>
                                <td className="px-4 py-2">{p.servicioNombre}</td>
                                <td className="px-4 py-2 font-semibold">${(p.precioCotizacionCliente || 0).toFixed(2)}</td>
                                <td className="px-4 py-2">{p.responsableNombre}</td>
                                {reportType === 'pending' && (
                                    <>
                                        <td className="px-4 py-2"><StatusBadge status={p.deliveryStatus} /></td>
                                        <td className="px-4 py-2 text-sm" title={p.notasSupervisor}>
                                            <p className="w-32 truncate">{p.notasSupervisor || '---'}</p>
                                        </td>
                                        <td className="px-4 py-2 text-sm text-gray-600">
                                            {formatDate(p.fechaApertura)}
                                        </td>
                                        <td className="px-4 py-2 text-center font-bold">
                                            {getDaysElapsed(p.fechaApertura)}
                                        </td>
                                    </>
                                )}
                                <td className="px-4 py-2 text-sm">{reportType === 'delivered' ? p.notaEntregaNumero : formatDate(p.fechaEntregaInterna)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="bg-gray-100 border-t-2">
                        <tr>
                            <td className="px-4 py-3 font-bold text-right text-sm" colSpan="2">
                                Total {reportType === 'delivered' ? 'Entregado' : 'Pendiente'} ({totalLabel}):
                            </td>
                            <td className="px-4 py-3 font-bold text-lg text-gray-900">${totalSum.toFixed(2)}</td>
                            <td colSpan={reportType === 'delivered' ? 2 : 6}></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div className="mt-4 flex justify-between items-center">
                 <span className="text-sm text-gray-700">Página {currentPage} de {totalPages}</span>
                <div>
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 border rounded-md bg-white mr-2 disabled:opacity-50">Anterior</button>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} className="px-3 py-1 border rounded-md bg-white disabled:opacity-50">Siguiente</button>
                </div>
            </div>
        </div>
    );
};

// Componente que para crear la tabla de cuentas por cobrar
const FinancialTrackingTable = ({ title, invoices, getInvoiceStatusBadge }) => {
    const [statusFilter, setStatusFilter] = useState('');
    const [monthFilter, setMonthFilter] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10)

    const { filteredInvoices, totalSum } = React.useMemo(() => {
        let filtered = statusFilter
            ? invoices.filter(inv => inv.estado === statusFilter)
            : invoices;

        if (monthFilter) {
            const selectedMonth = parseInt(monthFilter, 10);
            filtered = filtered.filter(inv => inv.fechaPromesaPago?.toDate().getMonth() === selectedMonth);
        }

        const sum = filtered.reduce((acc, inv) => acc + (inv.monto || 0), 0);
        return { filteredInvoices: filtered, totalSum: sum };
    }, [invoices, statusFilter, monthFilter]);

    const monthOptions = React.useMemo(() => {
        const availableMonths = new Set();
        invoices.forEach(inv => {
            if (inv.fechaPromesaPago?.toDate) {
                availableMonths.add(inv.fechaPromesaPago.toDate().getMonth());
            }
        });

        const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        
        const options = Array.from(availableMonths)
            .sort((a, b) => a - b)
            .map(monthNumber => ({
                value: String(monthNumber),
                label: monthNames[monthNumber]
            }));

        return [{ value: '', label: 'Todos los Meses' }, ...options];
    }, [invoices]);

    const currentItems = filteredInvoices.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4">{title}</h2>
            <div className="mb-4 flex justify-between items-center">
                <div className="flex items-center space-x-2">
                    <label htmlFor={`${title}-status-filter`} className="text-sm font-medium">Estado:</label>
                    <select id={`${title}-status-filter`} value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage(1); }} className="border-gray-300 rounded-md p-2 text-sm">
                        <option value="">Todos</option>
                        <option value="Pend. de Autorización">Pend. Autorización</option>
                        <option value="Prog. a Pago">Prog. a Pago</option>
                        <option value="Vencida">Vencida</option>
                    </select>
                </div>
                <div className="flex items-center space-x-2">
                    <label htmlFor={`${title}-month-filter`} className="text-sm font-medium">Mes Pago Prog.:</label>
                    <select id={`${title}-month-filter`} value={monthFilter} onChange={(e) => { setMonthFilter(e.target.value); setCurrentPage(1); }} className="border-gray-300 rounded-md p-2 text-sm">
                        {monthOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                    </select>
                </div>
                 <div className="flex items-center">
                    <span className="text-sm mr-2">Mostrar:</span>
                    <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }} className="px-2 py-1 border border-gray-300 rounded-md">
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={25}>25</option>
                    </select>
                </div>
            </div>

            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Estado</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Monto</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Fecha Prog. Pago</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Planta</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Servicio</th>
                            <th className="px-4 py-2 text-left text-xs font-medium uppercase">Factura</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {currentItems.map(inv => (
                            <tr key={inv.id}>
                                <td className="px-4 py-2">{getInvoiceStatusBadge(inv.estado)}</td>
                                <td className="px-4 py-2 font-semibold text-gray-900">${(inv.monto || 0).toFixed(2)}</td>
                                <td className="px-4 py-2">{formatDate(inv.fechaPromesaPago)}</td>
                                <td className="px-4 py-2">{inv.planta || 'N/A'}</td>
                                <td className="px-4 py-2">{inv.servicio || 'General'}</td>
                                <td className="px-4 py-2">{inv.folio}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="bg-gray-100">
                        <tr>
                            <td className="px-4 py-3 font-bold text-right">Total:</td>
                            <td className="px-4 py-3 font-bold text-lg text-gray-900" colSpan="4">${totalSum.toFixed(2)}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div className="mt-4 flex justify-between items-center">
                <span className="text-sm text-gray-700">Página {currentPage} de {totalPages}</span>
                <div>
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 border rounded-md bg-white mr-2 disabled:opacity-50">Anterior</button>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} className="px-3 py-1 border rounded-md bg-white disabled:opacity-50">Siguiente</button>
                </div>
            </div>
        </div>
    );
};

// Componente que para crear la tabla de cuentas por pagar
    const AccountsPayableDirectiveTable = ({ invoices, projectsMap }) => {
        const [providerFilter, setProviderFilter] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(10);
        const providers = React.useMemo(() => {
            const names = invoices
                .map(inv => inv.proveedorNombre)
                .filter(name => name && name.trim() !== '');
            return [...new Set(names)].sort();
        }, [invoices]);

        const { processedInvoices, totalSum } = React.useMemo(() => {
        const activeInvoices = invoices.filter(inv =>
            inv.estado === 'Pend. de Autorización' ||
            inv.estado === 'Prog. a Pago' ||
            inv.estado === 'Vencida'
        );

        const filteredByProvider = providerFilter
            ? activeInvoices.filter(
                inv => inv.proveedorNombre === providerFilter
            )
            : activeInvoices;

        const sum = filteredByProvider.reduce(
            (acc, inv) => acc + (inv.monto || 0),
            0
        );

        const finalInvoices = filteredByProvider
            .map(inv => {
                let projectBillingStatus = 'N/A';

                if (inv.proyectoId && inv.proyectoId !== 'general') {
                    const project = projectsMap.get(inv.proyectoId);

                    projectBillingStatus =
                        project?.facturasClienteIds?.length > 0
                            ? 'Facturado'
                            : 'No Facturado';
                }

                return {
                    ...inv,
                    projectBillingStatus
                };
            });
            if (providerFilter) {
                finalInvoices.sort((a, b) =>
                    String(a.folio || '').localeCompare(
                        String(b.folio || ''),
                        'es',
                        {
                            numeric: true,
                            sensitivity: 'base'
                        }
                    )
                );
            }

        return {
            processedInvoices: finalInvoices,
            totalSum: sum
        };
    }, [invoices, providerFilter, projectsMap]);

    const currentItems = processedInvoices.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(processedInvoices.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const getInvoiceStatusBadge = (status) => {
        const styles = {
            'Prog. a Pago': 'bg-blue-100 text-blue-800',
            'Pend. de Autorización': 'bg-yellow-100 text-yellow-800',
            'Vencida': 'bg-red-100 text-red-800',
        };
        return <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${styles[status] || 'bg-gray-100'}`}>{status}</span>;
    };

    const getProjectBillingStatusBadge = (status) => {
        const styles = {
            'Facturado': 'bg-green-100 text-green-800',
            'No Facturado': 'bg-red-100 text-red-800',
            'N/A': 'bg-gray-100 text-gray-700',
        };
        return <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${styles[status] || 'bg-gray-100'}`}>{status}</span>;
    };

    return (
        <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4">Cuentas por Pagar</h2>
            <div className="mb-4 flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="w-full md:w-auto">
                    <label htmlFor="provider-filter" className="text-sm font-medium mr-2">Filtrar por Proveedor:</label>
                    <select
                        id="provider-filter"
                        value={providerFilter}
                        onChange={(e) => { setProviderFilter(e.target.value); setCurrentPage(1); }}
                        className="border-gray-300 rounded-md p-2 text-sm w-full md:w-auto"
                    >
                        <option value="">Todos los Proveedores</option>
                        {providers.map(prov => <option key={prov} value={prov}>{prov}</option>)}
                    </select>
                </div>
                 <div className="flex items-center">
                    <span className="text-sm mr-2">Mostrar:</span>
                    <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }} className="px-2 py-1 border border-gray-300 rounded-md">
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={25}>25</option>
                    </select>
                </div>
            </div>

            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Factura</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Proveedor</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Monto</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Fecha Prog. Pago</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Estatus</th>
                            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Estatus Cobro</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {currentItems.length === 0 ? (
                            <tr><td colSpan="6" className="text-center py-4 text-gray-500">No hay cuentas por pagar activas.</td></tr>
                        ) : (
                            currentItems.map(inv => (
                                <tr key={inv.id} className="hover:bg-gray-50">
                                    <td className="px-4 py-2">{inv.folio}</td>
                                    <td className="px-4 py-2">{inv.proveedorNombre || 'N/A'}</td>
                                    <td className="px-4 py-2 font-semibold text-gray-900">${(inv.monto || 0).toFixed(2)}</td>
                                    <td className="px-4 py-2">
                                        {inv.fechaPromesaPago ? new Date(inv.fechaPromesaPago.seconds * 1000).toLocaleDateString('es-MX') : '-'}
                                    </td>
                                    <td className="px-4 py-2">{getInvoiceStatusBadge(inv.estado)}</td>
                                    <td className="px-4 py-2">{getProjectBillingStatusBadge(inv.projectBillingStatus)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                    <tfoot className="bg-gray-100">
                        <tr>
                            <td className="px-4 py-3 font-bold text-right" colSpan="2">Total:</td>
                            <td className="px-4 py-3 font-bold text-lg text-gray-900" colSpan="4">${totalSum.toFixed(2)}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            
            <div className="mt-4 flex justify-between items-center">
                <span className="text-sm text-gray-700">Página {currentPage} de {totalPages || 1}</span>
                <div>
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="px-3 py-1 border rounded-md bg-white mr-2 disabled:opacity-50">Anterior</button>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} className="px-3 py-1 border rounded-md bg-white disabled:opacity-50">Siguiente</button>
                </div>
            </div>
        </div>
    );
};

// Componente para la grafica de montos entregados por tecnico mensual
const TechnicianRevenueChart = ({ chartData }) => {
    const data = {
        labels: chartData.labels,
        datasets: chartData.datasets,
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom' },
            title: { display: false },
            tooltip: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';
                        if (label) label += ': ';
                        if (context.parsed.y !== null) {
                            label += new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(context.parsed.y);
                        }
                        return label;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return '$' + new Intl.NumberFormat('es-MX').format(value);
                    }
                }
            }
        }
    };

    return <Line data={data} options={options} />;
};
